<template>
    <div style="display: flex">
        <p class="legend" :style="{ backgroundColor: bgColor, color: color }">
            <span class="legend-text">{{ description }}</span>
        </p>
    </div>
</template>

<script>
export default {
    name: 'LegendInfo',
    props: {
        description: {
            type: String,
            default: ''
        },
        bgColor: {
            type: String,
            default: '#ff0909'
        },
        color: {
            type: String,
            default: '#fff'
        }
    }
}
</script>

<style scoped>
.legend {
    width: minmax(80px, max-content);
    border-radius: 4px;
    text-align: center;
    margin: 2px;
}

.legend-text {
    padding: 4px;
    border-radius: 4px;
    font-weight: 600;
}
</style>
